if (!customElements.get('free-gift')) {
  customElements.define(
    'free-gift',
    class FreeGift extends BaseElement {
      constructor() {
        super();

        this.variantId = this.getAttribute('data-variant-id');
        this.minimumAmount = parseInt(this.getAttribute('data-minimum-amount'));
        this.cartTotal = parseInt(this.getAttribute('data-cart-total'));
        this.giftQty = parseInt(this.getAttribute('data-gift-qty'));
        this.giftLineKey = this.getAttribute('data-gift-line-key');
      }

      connectedCallback() {
        super.connectedCallback();

        if (!this.variantId || isNaN(this.minimumAmount) || isNaN(this.cartTotal)) return;

        const eligible = this.cartTotal >= this.minimumAmount;

        // Reconcile desired vs. actual state. Re-renders after our own fetch
        // reconnect this element with fresh data attributes, so this settles
        // rather than looping, the same way gift-wrapping.js does.
        if (eligible && this.giftQty === 0) {
          this.addGift();
        }
        else if (!eligible && this.giftQty > 0 && this.giftLineKey) {
          this.removeGift();
        }
      }

      addGift() {
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          items: [
            {
              id: this.variantId,
              quantity: 1,
              properties: {
                '_free_gift': 'true'
              }
            }
          ],
          sections: sectionsToBundle
        });

        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(theme.routes.cart_add_url, { ...theme.utils.fetchConfig('javascript'), body, signal: this.abortController.signal })
          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status) return;

            const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
            cartJson['sections'] = parsedState['sections'];
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift', cart: cartJson });
          })
          .catch((error) => {
            if (error.name !== 'AbortError') console.error(error);
          });
      }

      removeGift() {
        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

        const body = JSON.stringify({
          updates: {
            [this.giftLineKey]: 0
          },
          sections: sectionsToBundle
        });

        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(theme.routes.cart_update_url, { ...theme.utils.fetchConfig(), body, signal: this.abortController.signal })
          .then((response) => response.json())
          .then((parsedState) => {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift', cart: parsedState });
          })
          .catch((error) => {
            if (error.name !== 'AbortError') console.error(error);
          });
      }
    }
  );
}
